import { registerFr } from '../i18n/index.js';

registerFr({
  'Writing profile': 'Profil d’écriture',
  'How this person and the operator actually write to each other: counts in and out, median reply hours and word counts either side, the greeting and sign-off verbatim, and the register the evidence supports. Every value reads "not collected" until there are at least two messages — a profile guessed from one mail is worse than no profile.': 'Comment cette personne et l’opérateur s’écrivent réellement : nombre de messages entrants et sortants, médiane du délai de réponse et du nombre de mots de part et d’autre, formule d’appel et de politesse mot pour mot, et le registre que les preuves soutiennent. Chaque valeur affiche « non relevé » tant qu’il y a moins de deux messages — un profil deviné à partir d’un seul courriel vaut moins que pas de profil.',

  'The writing profile could not be read.': 'Le profil d’écriture n’a pas pu être lu.',
  'Reading the correspondence…': 'Lecture de la correspondance…',
  'messages': 'messages',
  'from them': 'd’eux',
  'from you': 'de vous',
  'rhythm': 'rythme',
  'you answer in': 'vous répondez en',
  'they answer in': 'ils répondent en',
  'median': 'médiane',
  'h': 'h',
  'length': 'longueur',
  'yours': 'les vôtres',
  'theirs': 'les leurs',
  'words': 'mots',
  'greeting': 'formule d’appel',
  'sign-off': 'formule de politesse',
  'verbatim, your own': 'mot pour mot, la vôtre',
  'no greeting on record': 'aucune formule d’appel relevée',
  'no sign-off on record': 'aucune formule de politesse relevée',
  'register': 'registre',
  'formal (Sie / vous)': 'vouvoiement (Sie / vous)',
  'familiar (du / tu)': 'tutoiement (du / tu)',
  'German': 'allemand',
  'French': 'français',
  'English': 'anglais',
  'Italian': 'italien',
  'read from their own lines; nobody has held it': 'lu dans leurs propres lignes ; personne ne l’a retenu',
  '{n} lines': '{n} lignes',
  'no evidence': 'aucune preuve',
  'Fewer than two messages with this person are on the record, so nothing above was measured. Every value reads "not collected" rather than zero: a profile guessed from one mail would send the next draft out in the wrong voice.':
    'Moins de deux messages avec cette personne figurent au dossier : rien n’a donc été mesuré ci-dessus. Chaque valeur affiche « non relevé » plutôt que zéro — un profil deviné à partir d’un seul courriel enverrait le prochain brouillon sur le mauvais ton.',
}, 'WritingProfile');
